import { FadeUp } from "@/components/site/Reveal";
import { WAREHOUSES, MEDIA } from "@/lib/assets";
import { MapPin } from "lucide-react";

export const Warehouses = () => {
  return (
    <section id="network" data-testid="warehouses-section" className="bg-background py-28 md:py-40 border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <FadeUp>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Our Network</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
                Five warehouses,<br /> two states.
              </h2>
              <p className="text-muted-foreground mt-8 max-w-md leading-relaxed">
                Strategically located stocking points across Bhiwandi (Maharashtra) and Ahmedabad (Gujarat) keep
                inventory close to your production line — with quick sheet-cutting on site.
              </p>
              <div className="mt-10 overflow-hidden border border-border">
                <img src={MEDIA.forkliftRoll} alt="Warehouse operations" className="w-full h-64 object-cover" />
              </div>
            </FadeUp>
          </div>

          <div className="lg:col-span-7">
            <div className="border border-border divide-y divide-border">
              {WAREHOUSES.map((w, i) => (
                <FadeUp key={w.name} delay={i * 0.06}>
                  <div className="p-6 md:p-7 flex gap-5 group hover:bg-muted transition-colors duration-300" data-testid={`warehouse-${i}`}>
                    <MapPin size={22} className="text-primary shrink-0 mt-1" strokeWidth={1.5} />
                    <div>
                      <div className="flex items-baseline gap-3 flex-wrap">
                        <h3 className="font-display text-2xl">{w.name}</h3>
                        <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-primary">{w.city}</span>
                      </div>
                      <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{w.address}</p>
                    </div>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
